import { Provider } from '@angular/core'
import { ContractDeclarationService } from 'game-services'
import { GamePlayConfig } from 'shared-services'
import { gamePlayConfigToken } from 'shared-components'

export const contractDeclarationServiceProvider: Provider = {
  provide: ContractDeclarationService,
  useFactory: (gamePlayConfig: GamePlayConfig): ContractDeclarationService => {
    return new ContractDeclarationService(gamePlayConfig)
  },
  deps: [gamePlayConfigToken],
}
